import Product from '../../domains/Product/Product'
import { SvDetails } from '../../domains/ProductPurchaseInfo'

import { getVariantDetailsByIdForProductVariants } from './NewCheckoutProductService'

export async function getSvDetailsByIdForProductVariants(product: Product): Promise<Record<number, SvDetails>> {
  return await getVariantDetailsByIdForProductVariants(product)
}
